export const MIN_DURATION = 30;
export const DEVICE_LIST = [
  {
    name: "Mobile",
    icon: (
      <svg
        aria-hidden="true"
        className="w-5 h-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M6.709 0H17.29a1.326 1.326 0 0 1 1.324 1.323v21.354a1.326 1.326 0 0 1-1.323 1.324H6.708a1.327 1.327 0 0 1-1.324-1.324V1.323A1.326 1.326 0 0 1 6.71 0Zm4.112 21.883h2.359a.544.544 0 0 1 0 1.086H10.82a.545.545 0 0 1-.543-.543c0-.299.245-.543.543-.543Zm-4.234-1.032h10.826V3.15H6.587V20.85ZM16.89 1.308a.267.267 0 0 0 0 .533h.03a.267.267 0 0 0 0-.533h-.03Zm-9.812 0a.267.267 0 0 0 0 .533h.03a.267.267 0 0 0 0-.533h-.03Zm3.41 0h3.023v.533h-3.024v-.533Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    width: 360,
  },
  {
    name: "Tablet",
    icon: (
      <svg
        aria-hidden="true"
        className="w-5 h-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M4.245 0h15.51a1.477 1.477 0 0 1 1.472 1.473v21.055A1.477 1.477 0 0 1 19.755 24H4.245a1.477 1.477 0 0 1-1.472-1.473V1.473A1.477 1.477 0 0 1 4.245 0Zm6.542 22.4h2.426v.534h-2.426V22.4Zm.618-21.335a.267.267 0 1 0 0 .533.267.267 0 0 0 0-.533Zm1.19 0a.267.267 0 1 0 0 .533.267.267 0 0 0 0-.533Zm-8.263 1.6h15.336v18.67H4.332V2.666Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    width: 471,
  },
  {
    name: "Desktop",
    icon: (
      <svg
        aria-hidden="true"
        className="w-5 h-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M1.503 2C.676 2 0 2.677 0 3.503v12.471c0 .827.676 1.503 1.503 1.503h20.994c.827 0 1.503-.676 1.503-1.503V3.503C24 2.676 23.324 2 22.497 2H1.503Zm20.671 1.777a.214.214 0 0 1 .21.21V15.13H1.615V3.988a.214.214 0 0 1 .21-.21h20.35Z"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M13.835 20.61v-3.295h-3.67v3.296h3.67Z"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M18.353 21.49c0-.572-.469-1.04-1.041-1.04H6.688c-.572 0-1.04.468-1.04 1.04v1.042h12.705V21.49Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    width: 555,
  },
];

export const LINKEDIN_PUBLISH_TYPES = {
  PERSONAL: "personal",
  COMPANY: "company",
};

export const ROLES = {
  ADMIN: "ADMIN",
  CLIENT: "CLIENT",
  TEAM_MEMBER: "TEAM_MEMBER",
  CONTENT_MANAGER: "CONTENT_MANAGER",
};

export const ORG_ROLES = {
  ORG_OWNER: "ORG_OWNER",
  ORG_ADMIN: "ORG_ADMIN",
  ORG_MEMBER: "ORG_MEMBER",
};

export const PROFILE_MENU_ITEMS = {
  PAYMENTS_AND_PLANS: "Payments & Plans",
  AI_USAGE_AND_LIMITS: "AI Usage & Limits",
  MANAGE_WORKSPACES: "Manage All Workspaces",
  FEATURE_REQUEST: "Feature Request",
  HELP_CENTER: "Help Center",
  LOGOUT: "Logout",
};

export const PROFILE_MENU_ROUTES = {
  PAYMENTS_AND_PLANS: "/account/plan-details",
  AI_USAGE_AND_LIMITS: "/account/usage-and-limits",
};

export const SIDEBAR_CATEGORIES = {
  COMMON: "Common",
  CHALLENGES: "Challenges",
  CONTENT_CREATION: "Content Creation",
  ENGAGEMENT: "Engagement",
  DRAFTS_AND_SCHEDULING: "Drafts & Scheduling",
  CONTENT_INSPIRATION: "Content Inspiration",
  AUTOMATION: "Automation",
  INTEGRATIONS: "Integrations",
};

export const SIDEBAR_ROUTES = {
  DASHBOARD: "/",
  SETTINGS: "/workspace/setting",
  ANALYTICS: "/analytics",
  CHALLENGES: "/challenges",
  POST_GENERATOR: "/ai",
  IDEA_GENERATOR: "/ai/ideas-generator",
  CREATIVE_STUDIO: "/creative-studio",
  ENGAGE: "/engage",
  DRAFTS: "/posts/drafts",
  CALENDAR: "/calendar",
  CONTENT_RADAR: "/content-radar",
  VIRAL_POSTS: "/viral-posts",
  INFLUENCERS: "/influencers",
  AUTO_PILOT: "/posts-for-you",
  POST_CAST: "/post-cast",
  KANBAN: "/kanban",
  KNOWLEDGE_BASE: "/knowledge-base",
  MCP: "/mcp",
};

export const ROLE_UI_CONFIG = {
  [ROLES.CLIENT]: {
    topbar: {
      showWorkspaceSwitcherOptions: false,
    },
    profileMenu: {
      disabledRoutes: [
        PROFILE_MENU_ITEMS.PAYMENTS_AND_PLANS,
        PROFILE_MENU_ITEMS.AI_USAGE_AND_LIMITS,
        PROFILE_MENU_ITEMS.MANAGE_WORKSPACES,
        PROFILE_MENU_ITEMS.FEATURE_REQUEST,
      ],
    },
    sidebar: {
      showCreatePost: false,
      disabledCategories: [
        SIDEBAR_CATEGORIES.CONTENT_CREATION,
        SIDEBAR_CATEGORIES.CONTENT_INSPIRATION,
        SIDEBAR_CATEGORIES.AUTOMATION,
        SIDEBAR_CATEGORIES.ENGAGEMENT,
      ],
      disabledRoutes: [
        SIDEBAR_ROUTES.SETTINGS,
        SIDEBAR_ROUTES.POST_GENERATOR,
        SIDEBAR_ROUTES.IDEA_GENERATOR,
        SIDEBAR_ROUTES.CREATIVE_STUDIO,
        SIDEBAR_ROUTES.ENGAGE,
        SIDEBAR_ROUTES.VIRAL_POSTS,
        SIDEBAR_ROUTES.AUTO_PILOT,
        PROFILE_MENU_ROUTES.PAYMENTS_AND_PLANS,
        PROFILE_MENU_ROUTES.AI_USAGE_AND_LIMITS,
      ],
    },
  },
  [ROLES.ADMIN]: {
    topbar: {
      showWorkspaceSwitcherOptions: true,
    },
    profileMenu: {
      disabledRoutes: [],
    },
    sidebar: {
      showCreatePost: true,
      disabledCategories: [],
      disabledRoutes: [],
    },
  },
  [ROLES.TEAM_MEMBER]: {
    topbar: {
      showWorkspaceSwitcherOptions: true,
    },
    profileMenu: {
      disabledRoutes: [],
    },
    sidebar: {
      showCreatePost: true,
      disabledCategories: [],
      disabledRoutes: [],
    },
  },
  [ROLES.CONTENT_MANAGER]: {
    topbar: {
      showWorkspaceSwitcherOptions: true,
    },
    profileMenu: {
      disabledRoutes: [],
    },
    sidebar: {
      showCreatePost: true,
      disabledCategories: [],
      disabledRoutes: [],
    },
  },
  [ORG_ROLES.ORG_ADMIN]: {
    topbar: {
      showWorkspaceSwitcherOptions: true,
    },
    profileMenu: {
      disabledRoutes: [],
    },
    sidebar: {
      showCreatePost: true,
      disabledCategories: [],
      disabledRoutes: [],
    },
  },
};

export const USER_TYPE = {
  INDIVIDUAL_CREATOR: "individual_creator",
  GHOST_WRITER_AGENCY_OWNER: "ghostwriter/agency_owner",
};

export const USER_ROLE_NAMES = {
  ADMIN: "Admin",
  CLIENT: "Client",
  TEAM_MEMBER: "Team Member",
  CONTENT_MANAGER: "Content Manager",
  ORG_ADMIN: "Org Admin",
};

export const STATUS_COLOR_CODES = [
  {
    id: 'draft',
    label: 'Draft',
    textColor: 'text-gray-400',
    dotColor: 'bg-gray-400',
    bgColor: 'bg-gray-100',
  },
  {
    id: 'under_review',
    label: 'In-Review',
    textColor: 'text-cyan-400',
    dotColor: 'bg-cyan-400',
    bgColor: 'bg-blue-50',
  },
  {
    id: 'needs_changes',
    label: 'Changes Needed',
    textColor: 'text-warning-400',
    dotColor: 'bg-warning-400',
    bgColor: 'bg-warning-50',
  },
  {
    id: 'approved',
    label: 'Approved',
    textColor: 'text-success-400',
    dotColor: 'bg-success-400',
    bgColor: 'bg-success-50',
  },
  {
    id: 'scheduled',
    label: 'Scheduled',
    textColor: 'text-purple-500',
    dotColor: 'bg-purple-500',
    bgColor: 'bg-purple-50',
  },
  {
    id: 'published',
    label: 'Published',
    textColor: 'text-success-600',
    dotColor: 'bg-success-600',
    bgColor: 'bg-success-50',
  },
];

export const POSTHOG_FEATURE_TOGGLES = {
  POST_CAST: "feature_post_cast",
  KNOWLEDGE_BASE: "feature_content_memory",
};

export const SUPPORT_EMAIL = "support@supergrow.ai";

export const BEST_PILLARS = {
  BOND: "bond",
  EDUCATE: "educate",
  SHOWCASE: "showcase",
  TELL: "tell",
};

export const CONTENT_INTERVIEW_STATUSES = {
  DRAFT: "draft",
  PUSHED: "pushed",
  COMPLETED: "completed",
};

export const INTERVIEW_INPUT_TYPES = {
  TOPIC: "topic",
  TEXT_CONTENT: "text_content",
  PREVIOUS_POST_CAST_SESSION: "previous_post_cast_session",
};
